import { render, staticRenderFns } from "./UpdateSuppliersModal.vue?vue&type=template&id=280b2999&scoped=true&"
import script from "./UpdateSuppliersModal.vue?vue&type=script&lang=js&"
export * from "./UpdateSuppliersModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSuppliersModal.vue?vue&type=style&index=0&id=280b2999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b2999",
  null
  
)

export default component.exports